import React, { useRef } from "react";

import * as S from "./styles";

export const Slide4: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <S.Container>
      <S.Background>
        <S.Video>
          <video ref={videoRef} muted autoPlay loop playsInline>
            <source
              src="https://player.vimeo.com/external/538839237.hd.mp4?s=d7b22bbcb26a78a572be069695f49aa98eb8a9bc&profile_id=175&download=1"
              type="video/mp4"
            />
          </video>
        </S.Video>
      </S.Background>
    </S.Container>
  );
};
